function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".\\37 b6f7ec6-4c02-4edf-8b95-a4b3b144a12e{fill:none;stroke:#f7941d;stroke-miterlimit:10;stroke-width:8px;}.dc13e663-5bd2-4634-8d55-692f92256b7e{fill:#1d184d;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "logo-text");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "733c750a-c3e1-42a1-9b23-6f70901cbe2b",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "480259c3-fdaf-4d64-9188-c196ff17729d",
  "data-name": "Layer 1-2"
}, React.createElement("path", {
  className: "7b6f7ec6-4c02-4edf-8b95-a4b3b144a12e",
  d: "M191.6,139.1V22.3l51.9,51.9,38.7-49.4,37,55.3L376,16.4v137a200.1,200.1,0,0,1-2.9,35.2,43.8,43.8,0,0,1-41.3,35.8H190.6a32.5,32.5,0,0,1-23-9.5h0a38.3,38.3,0,0,1,0-54.2h0a19,19,0,0,1,13.5-5.6H327a19,19,0,0,1,13.5,5.6h0c3.7,3.7,5.3,10,5,16.2a13.2,13.2,0,0,1-6.8,10.9,13.8,13.8,0,0,1-13.5-.2l-6.4-3.6",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "7b6f7ec6-4c02-4edf-8b95-a4b3b144a12e",
  d: "M331.8,224.4c-17-2.2-31.8-17.4-31.8-34.6a34.5,34.5,0,0,1,30.1-34.2",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M53.5,265.5a31.8,31.8,0,0,0-9.2-5.5A28.4,28.4,0,0,0,34,258.1q-10.4,0-16.9,6.6T10.7,282q0,10.2,6.3,16.9a21.1,21.1,0,0,0,16,6.6,29.1,29.1,0,0,0,10.7-2,34.2,34.2,0,0,0,9.7-6v11.6a30.5,30.5,0,0,1-9,4.4A36.4,36.4,0,0,1,33.9,315a37,37,0,0,1-13.4-2.4A31.6,31.6,0,0,1,2.5,295a35.7,35.7,0,0,1,0-26.1,32.4,32.4,0,0,1,18-17.8,35.7,35.7,0,0,1,13.2-2.4,34.5,34.5,0,0,1,10.6,1.6,37.1,37.1,0,0,1,9.8,4.9Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M107.9,313.4l-7.2-16.3h-25l-7.4,16.3H57.6l30.6-65.7,30.5,65.7ZM79.5,288.5H97.1l-6.5-14.4c-.4-.9-.8-2-1.2-3.2s-.8-2.5-1.2-4c-.3,1.4-.7,2.7-1.1,3.9s-.8,2.3-1.2,3.3Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M134.3,285.1v28.3h-9.6V250.2H139a44.8,44.8,0,0,1,9.8.8,15.4,15.4,0,0,1,5.9,2.7,14.9,14.9,0,0,1,4.5,5.9,19.4,19.4,0,0,1,1.6,7.9q0,7.6-3.7,11.9c-2.4,2.9-6.1,4.6-10.8,5.2l21.8,28.7H156.5l-21-28.3Zm.6-8h1.9q8.2,0,10.8-1.9t2.7-6.7c0-3.5-1-5.9-2.9-7.4S142,259,136.8,259H135Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M183.8,285v28.4h-9.6V250.2h15.5a49.6,49.6,0,0,1,10.2.8,15.9,15.9,0,0,1,5.7,2.5,14.8,14.8,0,0,1,4.7,5.9,19.8,19.8,0,0,1,1.7,8.2,20.3,20.3,0,0,1-1.7,8.3,14.4,14.4,0,0,1-4.7,6,15.6,15.6,0,0,1-5.7,2.5,50.7,50.7,0,0,1-10.2.7h-5.9Zm.6-8.4h2.6q8.5,0,11.4-1.9t2.9-6.6c0-3.4-1-5.7-3.1-7.1s-5.8-2.1-11.2-2.1h-2.6Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M221.3,313.4V250.2h35.3v8.7h-25v15.8h25v9h-25v20.4h25v9.2Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M288.7,258.9v54.5H278.4V258.9H261.6v-8.7h43.8v8.7Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M339.9,313.4V250.2h10.3v26.1l22.7-26.1h12.5l-25,28.1,28,35.1H375.2l-25-32.3v32.3Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M394.9,313.4V250.2h10.3v63.2Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M419.9,313.4V247.7l40.1,38.6,3.3,3.5,3.5,4.2V250.2h9.5v65.6l-41-39.3-3.2-3.4c-1-1.2-2-2.4-2.9-3.7v43.9Z",
  transform: "translate(0 -5.9)"
}), React.createElement("path", {
  className: "dc13e663-5bd2-4634-8d55-692f92256b7e",
  d: "M525.9,281h25v1.8c.1,2,.1,3.4.1,4.1q0,13.3-7.6,20.7T522,315a39,39,0,0,1-13.9-2.3,29.3,29.3,0,0,1-10.7-6.9,31.2,31.2,0,0,1-6.9-10.7,36.1,36.1,0,0,1-2.4-13.2,34.9,34.9,0,0,1,2.4-13.2,30.4,30.4,0,0,1,7.2-10.7,31.1,31.1,0,0,1,10.8-6.9,37,37,0,0,1,13.3-2.3,31.6,31.6,0,0,1,13.4,2.7,29.8,29.8,0,0,1,10.5,8.3l-7.5,5.6a20.9,20.9,0,0,0-7.2-5.5,21.6,21.6,0,0,0-9-1.8q-10.3,0-16.8,6.6t-6.5,17.1q0,10.7,6.5,17.4t16.8,6.7q8.8,0,13.8-4.1a13.6,13.6,0,0,0,5-11.2v-.9H525.9Z",
  transform: "translate(0 -5.9)"
})));

var SvgLogoText = function SvgLogoText(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "fcc24e8c-e98e-463e-8c6f-b44187c7a1e6",
    "data-name": "Layer 1",
    viewBox: "0 0 551 309.9",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-text.78ee8af9.svg";
export { ForwardRef as ReactComponent };